<template>
  <div
    :class="classes"
    @click="changeRoute"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div class="nice-card-title">
      <v-layout row class="d-flex justify-space-between align-center mb-2 px-2">
        <div class="d-flex">
          <v-avatar
            v-if="icon"
            size="60"
            class="elevation-6 ms-5"
            :color="color"
          >
            <!-- <v-icon v-if="loading" dark size="50">
              mdi-loading mdi-spin
            </v-icon> -->
            <v-icon v-if="icon.startsWith('mdi')" dark size="50">
              {{ icon }}
            </v-icon>
            <!-- <s-icon v-else color="white" :icon="icon" size="50" /> -->
          </v-avatar>
        </div>
      </v-layout>
      <v-layout row class="d-flex justify-space-between align-center mb-2 px-2">
        <div class="d-flex flex-column">
          <div :class="`nice-card-title ms-5 text-h6 d-flex text-${color}`">
            <span :class="$vuetify.breakpoint.xs ? '' : 'd-none d-sm-block'">{{
              title
            }}</span>
            <span v-if="name" class="ms-2">- {{ name }}</span>
          </div>
          <div :class="`nice-card-title ms-5  d-flex text-${subtitle_color}`">
            <span :class="$vuetify.breakpoint.xs ? '' : 'd-none d-sm-block'">{{
              subtitle
            }}</span>
            <span v-if="subtitle_value" class="ms-2">
              {{ subtitle_value }}
            </span>
          </div>
        </div>
      </v-layout>
    </div>
    <div class="nice-card-body d-flex flex-column">
      <v-divider v-if="parameters.length" class="mt-1" />
      <v-layout row wrap class="justify-space-between align-stretch px-4 py-2">
        <v-flex
          v-for="(param, index) in parameters"
          :key="index"
          :class="`pt-0 pb-1 text-${parameters_color}`"
        >
          <v-icon v-if="param.icon" class="me-1" :color="parameters_color">
            {{ param.icon }}
          </v-icon>
          <span class="font-weight-medium me-2">{{ param.key }}:</span>
          <strong>{{ param.value }}</strong>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  name: "NiceCard",

  props: {
    type: {
      type: String,
      default: "",
    },
    to: {
      type: [String, Object],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    title: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    subtitle_value: {
      type: [String, Number],
      default: "",
    },
    subtitle_color: {
      type: String,
      default: "secondary",
    },
    parameters_color: {
      type: String,
      default: "info",
    },
    parameters: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    hover: false,
  }),

  computed: {
    classes() {
      let classes = ["nice-card", "rounded-lg"];
      if (this.to) {
        classes.push("clickable");
        if (this.hover) {
          classes.push("elevation-10");
        } else {
          classes.push("elevation-6");
        }
      }
      // else
      return classes.join(" ");
    },
    // color_text() {
    //   // const color = this.color.split(" ");
    //   // return `${color[0]}--text text--${color[1]}`;
    //   return `text-${this.color}`;
    // },
    // subtitle_color_text() {
    //   // const color = this.subtitle_color.split(" ");
    //   // return `${color[0]}--text text--${color[1]}`;
    //   return `text-${this.color}`;
    // },
    // parameters_color_text() {
    //   // const color = this.parameters_color.split(" ");
    //   // return `${color[0]}--text text--${color[1]}`;
    //   return `text-${this.color}`;
    // },
  },
  mounted() {
    //
  },
  methods: {
    changeRoute() {
      if (this.to == "devices") {
        localStorage.setItem("homePage", this.to);
        this.$router.push(this.to);
      } else {
        // localStorage.setItem("homePage", this.to);
        this.$router.push(this.to);
      }
    },
    // mouseover (hover) {
    //   console.log(hover)
    // },
    textSize(size) {
      switch (parseInt(size)) {
        case 1:
          return "text-h1";
        case 2:
          return "text-h2";
        case 3:
          return "text-h3";
        case 4:
          return "text-h4";
        case 5:
          return "text-h5";
        default:
          return "text-h3";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nice-card {
  min-height: 135px;
  min-width: 350px;
  margin-top: 20px;
  background-color: #fff;
  .d-flex.flex-column {
    margin-top: 10px;
  }
  .v-card__title {
    margin-bottom: 10px;
  }
  .v-avatar {
    border-radius: 6px;
    margin-top: -20px;
  }
}

.nice-card.clickable {
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.05);
  }
}
@media screen and (max-width: 600px) {
  .nice-card {
    min-height: 135px;
    width: 100%;
    // max-width: 200px;
    min-width: 170px;
    margin-top: 20px;
    background-color: #fff;
    .d-flex.flex-column {
      margin-top: 10px;
    }
    .v-card__title {
      margin-bottom: 10px;
    }
    .v-avatar {
      border-radius: 6px;
      margin-top: -20px;
    }
  }
}
</style>
